module.exports = __webpack_public_path__ + "static/SL88-bf01eee13b937cc9ec08d7586e156b51.png";